import React from 'react'
import styled from 'styled-components'

import EVENTS from '../../utils/events'

const Dimmer = styled.div`
  background: #424a5e;
  height: 100vh;
  width: 100%;
  position: fixed;
  z-index: 3;
  transform: translate3d(0, 0, 0.00002);
  opacity: 0.4;
  transition: opacity 0.5s ${(props) => props.theme.ease.ease_out_expo};
  top: 0;
  pointer-events: none;
  left: 0;
  &.hide {
    opacity: 0 !important;
  }
  &.secondary {
    z-index: 3;
  }
  &.primary {
    z-index: 4;
  }
  &.all {
    z-index: 100;
    opacity: 0.7;
  }
`

export default class Template extends React.PureComponent {
  _onDimmerOn(_e) {
    const modalCoverNavigation = _e.detail || EVENTS.CTRL.DEFAULT
    this.setState({ dim: true, cover: modalCoverNavigation })
  }
  _onDimmerOff() {
    this.setState({ dim: false })
  }

  constructor(props) {
    super(props)
    this.state = {
      dim: false
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener(
        EVENTS.CONTENT.DIMMER_ON,
        this._onDimmerOn.bind(this)
      )
      window.addEventListener(
        EVENTS.CONTENT.DIMMER_OFF,
        this._onDimmerOff.bind(this)
      )
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener(
        EVENTS.CONTENT.DIMMER_ON,
        this._onDimmerOn.bind(this)
      )
      window.removeEventListener(
        EVENTS.CONTENT.DIMMER_OFF,
        this._onDimmerOff.bind(this)
      )
    }
  }

  render() {
    return (
      <Dimmer
        out={!this.state.dim}
        className={
          this.state.dim
            ? `show ${this.state.cover}`
            : `hide ${this.state.cover}`
        }
        onMouseOver={this._handleMouseOver}
      />
    )
  }
}
